import React from 'react';
import { MoonIcon } from 'lucide-react';
interface HeaderProps {
  lockup: string;
}
export function Header({
  lockup
}: HeaderProps) {
  return <header className="sticky top-0 z-40 border-b border-gold/20 bg-ink/80 backdrop-blur-md" data-id="element-79" data-mp="2dmmmdzv5lhj2">
      <div className="mx-auto flex h-16 w-full max-w-6xl items-center justify-between gap-4 px-4 sm:h-20 sm:px-8" data-id="element-80" data-mp="2ik5zgwg47o9f">
        <a href="#inicio" className="flex min-w-0 items-center gap-2.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold sm:gap-3" data-id="element-81" data-mp="2nihcth5mcgwe">
          <MoonIcon className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-82" data-mp="2wjnuvunx1zrr" />
          <span className="truncate font-display text-[0.6rem] font-medium uppercase leading-tight tracking-[0.24em] text-paper sm:text-[0.8rem] sm:tracking-[0.3em]" data-id="element-83" data-mp="31d06n47hyc33">
            {lockup}
          </span>
        </a>

        <nav aria-label="Navegación principal" className="flex shrink-0 items-center gap-4 sm:gap-7" data-id="element-84" data-mp="3bbpr94qs2an1">
          <a href="#inicio" className="font-folio text-[0.68rem] uppercase tracking-[0.24em] text-body transition-colors hover:text-gold focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-85" data-mp="3f9dqgjzi6pkq">
            Inicio
          </a>
        </nav>
      </div>
    </header>;
}